<template>
  <Modal v-model="visible" :title="userInfo.userType == 3 ? '回款' : '付款'" width="1200" :mask-closable="false" :footer-hide="true" class="my-modal top p-b">
    <div class="modal-top">
      <span class="lable">是否已{{ userInfo.userType == 3 ? '回款' : '付款' }}</span>
      <i-switch v-model="payStatus" true-value="1" false-value="0" @on-change="changePay" :disabled="!$units.pointAction('offline_82_2_6') ? true : false" />
    </div>
    <div class="tableBox">
      <loading :isShow="listLoading" />
      <Button type="primary" class="add-btn" @click="$refs.addPayPopUpRef.open(reportId)">新增</Button>
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="payAccount">
          <div style="display: flex; align-items: center; white-space: nowrap; justify-content: center">
            <span class="text" v-if="row.eyeShow1">{{ row.payAccount1 }}</span>
            <span class="text" v-else>{{ row.payAccount }}</span>
            <div v-if="row.payAccount">
              <i class="iconfont iconxianshi eye-icon" v-if="row.eyeShow1" @click="openEye(row, 1)"></i>
              <i class="iconfont iconyincang eye-icon" v-else @click="openEye(row, 1)"></i>
            </div>
          </div>
        </template>

        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="delRow(row)">删除</span>
        </template>

        <template slot-scope="{ row }" slot="pic">
          <uploadNew :value="picUrlList(row)" :isDel="false" v-if="row.picUrl || row.billImages"></uploadNew>
        </template>
      </Table>
      <Page
        v-if="userInfo.userType != 3"
        :total="total"
        :current.sync="pageNum"
        :page-size="pageSize"
        show-total
        @on-change="getList"
        style="text-align: center; margin-top: 20px"
      />
    </div>
    <addPayPopUp ref="addPayPopUpRef" @success="searchAjax"></addPayPopUp>
  </Modal>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import addPayPopUp from './addPayPopUp';
import filter from '@/api/filter';
import uploadNew from '@/components/commons/uploadNew';

export default {
  mixins: [pageTool, common],
  components: { addPayPopUp, uploadNew },
  data() {
    let vm = this;
    return {
      userInfo: JSON.parse(window.localStorage.getItem('userInfo')),
      visible: false,
      payStatus: null,
      tableData: [],
      total: 0,
      columns: [
        {
          title: '凭证编号',
          align: 'center',
          minWidth: 150,
          render(h, params) {
            let userType = vm.userInfo.userType;
            if (userType == 3) {
              return <span>{params.row.collectionCode}</span>;
            } else {
              return <span>{params.row.voucherNo}</span>;
            }
          }
        },
        {
          title: '付款日期',
          align: 'center',
          minWidth: 150,
          render(h, params) {
            let userType = vm.userInfo.userType;
            if (userType == 3) {
              let collectionDate = params.row.collectionDate;
              return <span>{filter.filterTime(collectionDate, 'YYYY-MM-DD')}</span>;
            } else {
              let payTime = params.row.payTime;
              return <span>{filter.filterTime(payTime, 'YYYY-MM-DD')}</span>;
            }
          }
        },
        {
          title: '付款金额',
          align: 'center',
          minWidth: 150,
          render(h, params) {
            let userType = vm.userInfo.userType;
            if (userType == 3) {
              return <span>{params.row.collectionAmount}</span>;
            } else {
              return <span>{params.row.payAmount}</span>;
            }
          }
        },
        {
          title: '付款账户',
          align: 'center',
          slot: 'payAccount',
          minWidth: 200
        },
        {
          title: '凭证照片',
          align: 'center',
          width: 200,
          slot: 'pic'
        },
        {
          title: '备注',
          align: 'center',
          key: 'remark',
          minWidth: 200,
          tooltip: true,
          tooltipMaxWidth: 700
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 100,
          fixed: 'right'
        }
      ]
    };
  },

  methods: {
    // 解密
    openEye(row, key) {
      if (!row['eyeShow' + key]) {
        this.descrypt(
          {
            query: row.id,
            operationFunction: 22,
            operationType: 5
          },
          row,
          'payAccount1',
        ).then(() => {
          this.$set(row, 'eyeShow' + key, true);
        });
      } else {
        this.$set(row, 'eyeShow' + key, false);
      }
    },

    open(payStatus, reportId) {
      if (this.userInfo.userType == 3) {
        this.columns.forEach(item => {
          if (item.title.indexOf('付款') != -1) {
            item.title = item.title.replace('付款', '回款');
          }
        });
      }
      this.visible = true;
      this.payStatus = payStatus;
      this.reportId = reportId;
      this.searchAjax();
    },

    picUrlList(row) {
      if (this.userInfo.userType == 3) {
        return [{ fileName: '', path: row.billImages }];
      } else {
        return [{ fileName: '', path: row.picUrl }];
      }
    },

    changePay(val) {
      let data = {};
      if (this.userInfo.userType == 3) {
        data.returnedStatus = val;
        data.reportId = this.reportId;
      } else {
        data.id = this.reportId;
        data.payStatus = val;
      }
      this.$http({
        url: this.userInfo.userType == 3 ? '/buz/settlementReport/returned' : '/buz/settlementReport/edit',
        type: 'POST',
        data
      }).then(res => {
        this.$emit('change-pay');
      });
    },

    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },

    // 删除
    delRow(row) {
      this.$notice.inquiry('确定删除吗?').then(() => {
        if (this.userInfo.userType == 3) {
          this.$http({
            url: `/buz/settlementReport/delCheckReturnedMoney?id=${row.id}`,
            type: 'DELETE'
          }).then(res => {
            this.searchAjax();
            this.$notice.success('删除成功');
          });
        } else {
          this.$http({
            url: '/buz/settlementPaymentVoucher/del',
            type: 'GET',
            data: {
              id: row.id
            }
          }).then(res => {
            this.searchAjax();
            this.$notice.success('删除成功');
          });
        }
      });
    },

    getList() {
      this.listLoading = true;
      if (this.userInfo.userType == 3) {
        this.$http({
          url: '/buz/settlementReport/listCheckReturnedMoney?reportId=' + this.reportId,
          type: 'GET'
        })
          .then(res => {
            this.total = res.total;
            this.tableData = res.data;
            this.listLoading = false;
          })
          .catch(e => {
            this.listLoading = false;
          });
      } else {
        this.$http({
          url: '/buz/settlementPaymentVoucher/read/list',
          type: 'POST',
          data: {
            pageNo: this.pageNum,
            pageSize: this.pageSize,
            reportId: this.reportId
          }
        })
          .then(res => {
            this.total = res.total;
            this.tableData = res.data;
            this.listLoading = false;
          })
          .catch(e => {
            this.listLoading = false;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-top {
  margin-top: 10px;
  display: flex;
  .lable {
    margin-right: 10px;
  }
}
.tableBox {
  margin-top: 20px;
  .add-btn {
    margin-bottom: 10px;
  }
}
</style>
